var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWallet = function SvgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 18.35"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.18 0H3.82a3.73 3.73 0 0 0-.44 0h-.32A3 3 0 0 0 .45 2.06 3.77 3.77 0 0 0 0 3.81v8.37a1 1 0 0 0 0 .24c.23 2 1.4 3.54 2.89 3.62l10.41 2.3h.22c1.72 0 3.06-1.9 3.06-4.32V6.65c0-2.37-1.28-4.23-2.94-4.32L12.21 2h6a1.82 1.82 0 0 1 1.73 1.28h-2.42a1 1 0 0 0 0 2H20v6.89A1.83 1.83 0 0 1 18.18 14a1 1 0 0 0 0 2A3.83 3.83 0 0 0 22 12.18V3.81A3.83 3.83 0 0 0 18.18 0Zm-4.62 4.32c.37 0 1.06.88 1.06 2.32V14c0 1.36-.61 2.22-1 2.32L3.28 14.05h-.22C2.69 14 2 13.15 2 11.71V4.32a3.73 3.73 0 0 1 .28-1.46 1.82 1.82 0 0 1 1-.78l10 2.22Z"
  })));
};

export default SvgWallet;